














import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'HulaTry'
})
export default class Index extends Vue {
}
